import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "textDashboard" }
const _hoisted_2 = { class: "tituloMIN" }

import { computed, ref, onMounted, watch } from 'vue';
import { COLOR } from '@/constants/colors';


export default /*@__PURE__*/_defineComponent({
  __name: 'hexagonMinComponent',
  props: {
    title       : { type: String, required: true },
    secondInfo  : { type: Number, default: 0 },
    color       : { type: String, required: true },
    subtitle    : { type: String, required: true },
    sizeHexa    : { type: Number, default: 110 },
    sizeTitle   : { type: Number, default: 25 },
    sizeSubTi   : { type: Number, default: 15 },
    minValue    : { type: Number, default: 0.6 },
    maxValue    : { type: Number, default: 0.9 },
},
  setup(__props) {

const props = __props

const finalNumber   = computed(() => props.title);
const sizeHexa      = computed(() => props.sizeHexa);
const sizeTitle     = computed(() => props.sizeTitle);
const sizeSubTi     = computed(() => props.sizeSubTi);
const minValue      = computed(() => props.minValue);
const maxValue      = computed(() => props.maxValue);
const finalColor    = ref('');
const colorHexagon  = computed(() => finalColor.value);
const colorText     = ref('')
const finalColorT   = computed(() => colorText.value)

const getColorByNumber = () => {  
    let number = parseFloat(finalNumber.value);
    if (number >= maxValue.value) finalColor.value = COLOR.green
    if (number < maxValue.value && number >= minValue.value ) finalColor.value = COLOR.yellow
    if (number < minValue.value ) finalColor.value = COLOR.red;
    getColorText(finalColor.value)
}

const getColorText = (color:string) => {
    let colorT = '#FFFFFF';
    if(color === COLOR.yellow) colorT = '#000000';
    colorText.value = colorT;
}

watch(finalNumber,() => {
    getColorByNumber()
} )
watch(minValue,() => {
    getColorByNumber()
} )
watch(maxValue,() => {
    getColorByNumber()
} )

watch(finalColor, (color:string) => {
    let colorT = '#FFFFFF';
    if(color === COLOR.yellow) colorT = '#000000';

    colorText.value = colorT;
})

const styles = computed(() =>  ({
    '--varColor' : colorHexagon.value,
    '--varSizeHexa': `${sizeHexa.value}px`,
    '--varSizeTitle': `${sizeTitle.value}px`,
    '--varSizeSubTi': `${sizeSubTi.value}px`,
    '--varColorText' : finalColorT.value
}))

onMounted(() => {
    getColorByNumber()
})


return (_ctx: any,_cache: any) => {
  const _component_v_sheet = _resolveComponent("v-sheet")!

  return (_openBlock(), _createElementBlock("div", {
    style: _normalizeStyle(styles.value),
    class: "contenedorMIN"
  }, [
    _createVNode(_component_v_sheet, { class: "hexagonMIN" }),
    _createVNode(_component_v_sheet, {
      class: "subtituloMIN text-center",
      width: sizeHexa.value-5,
      color: "transparent"
    }, {
      default: _withCtx(() => [
        _createElementVNode("span", _hoisted_1, _toDisplayString(__props.subtitle), 1)
      ]),
      _: 1
    }, 8, ["width"]),
    _createElementVNode("span", _hoisted_2, _toDisplayString((parseFloat(__props.title)*100).toFixed()) + "% ", 1)
  ], 4))
}
}

})